<template>
  <div>
    <el-dialog
      :title="platFormTitle"
      :visible.sync="dialogFormVisible"
      width="60%"
      class="dialog"
      center
    >
      <div class="dialog-content">
        <div class="dialog-list" v-if="recordList && recordList.length">
          <div
            class="dialog-item"
            v-for="(item, index) in recordList"
            :key="index"
          >
            <span class="dialog-value">{{ item }}</span>
          </div>
        </div>
        <div v-else class="empty-text">暂无记录</div>
      </div>
      <div class="dialog-btn">
        <el-button type="primary" @click="handleCloseClick">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBoardingRecordList } from "@/api/logisticsControl/delivery/index";
export default {
  data() {
    return {
      dialogFormVisible: false,
      platFormTitle: "上车记录",
      recordList: [],
    };
  },
  methods: {
    async show(row) {
      this.dialogFormVisible = true;
      this.recordList = [];
      const res = await getBoardingRecordList({
        entruck_detail_id: row.id,
      });
      this.recordList = res.data || [];
    },
    handleCloseClick() {
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.dialog {
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
  .dialog-content {
    min-height: 100px;
    max-height: 500px;
    overflow-y: auto;
    .dialog-list {
      display: flex;
      flex-direction: column;
    }
    .dialog-item {
      padding: 10px;
      text-align: left;
      &:last-child {
        border-bottom: none;
      }
      .dialog-value {
        font-size: 14px;
        color: #333;
        line-height: 1.5;
      }
    }
    .empty-text {
      text-align: center;
      color: #999;
      padding: 20px;
    }
  }
  .dialog-btn {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
